/* eslint-disable @typescript-eslint/ban-types */
import { Icons } from "@/components/ui/icons";
import { metersToMilesFormatter } from "@/lib/formatters/distance-formatters";
import { sentenceCaseFormatter } from "@/lib/formatters/string-formatters";
import { AbsoluteDirectionSchema, RelativeDirectionSchema } from "@/services/otp/validations/planner.graphql";
import { AppStep } from "@/types/otp/+extended";

export function ItineraryDetailsStep({ bogusName, absoluteDirection, relativeDirection, streetName, distance }: AppStep) {
    const action = getAction(relativeDirection, absoluteDirection).toLowerCase()

    return (
        <div className="flex flex-row gap-2 items-center text-sm text-foreground">
            <span>
                {getIcon(relativeDirection)}
            </span>
            <span className="flex flex-row gap-1 items-center">
                {sentenceCaseFormatter(action?.replace('_', ' '))}
                {bogusName 
                    ? <>{" "} on {" "} the {" "} {streetName}</>
                    : <>{" "} on {" "} {streetName}</>
                }
            </span>
            <span className="text-subtle-foreground">
                {metersToMilesFormatter(distance)}
            </span>
        </div>
    )
}

function getAction(relativeDirection: RelativeDirectionSchema | (string & {}) | null | undefined, absoluteDirection: AbsoluteDirectionSchema | (string & {}) | null | undefined) {
    if (relativeDirection === "DEPART") {
        return `HEAD ${absoluteDirection}`
    }
        
    return `${relativeDirection}`
}

function getIcon(relativeDirection: RelativeDirectionSchema | (string & {}) | null | undefined) {
    if (!relativeDirection) {
        return <Icons.itinerary.walk />
    }

    if (typeof relativeDirection !== "string" || !(relativeDirection in Icons.itinerary.directions)) {
        return <Icons.itinerary.stop />
    }

    const PotentialIcon = Icons.itinerary.directions[relativeDirection as keyof typeof Icons.itinerary.directions];
    if (!PotentialIcon) {
        return <Icons.itinerary.walk />
    }

    return <PotentialIcon />
}